// Re-export the vendored jmuxer build.
// Upstream jmuxer@2.1.1 ships `"type":"module"` with a CJS UMD main file, so
// `import JMuxer from "jmuxer"` resolves to an empty module under CRA/webpack.
const JMuxer = require("./vendor/jmuxer.js");

export default JMuxer;
